import { DefaultContent, ErrorCard } from '../layouts';
import { useLocation, useNavigate } from 'react-router-dom';

import { Button } from '..';
import { DateFormat } from '../../utils';
import { DateFormatTypeEnum } from '../../enums';
import { FunctionComponent } from 'react';
import { useAuth } from '../../hooks';
import { useTranslation } from 'react-i18next';

const PUBLIC_URL = process.env.PUBLIC_URL;

const ErrorView: FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { authenticated, user } = useAuth();
  const location = useLocation();
  return (
    <DefaultContent>
      <ErrorCard>
        <div className="empty-body-card single-card text-center py-2">
          <img className="img-fluid" alt="Comportamento Inesperado" src={`${PUBLIC_URL}${'/assets/images/bot_500.png'}`} />
          <h1 className="display-4">{t('label.comportamento_inesperado')}</h1>
          <p className="lead">{t('texto.pagina_erro')}</p>
          <div className="bg-light w-100">
            <p className="fw-light">
              {t('label.usuario')}: {user?.nome}
            </p>
            <p className="fw-light">
              {t('label.data')}: <DateFormat originalDate={new Date().toString()} formatType={DateFormatTypeEnum.DATETIME} />
            </p>
            <p className="fw-light">
              {t('label.caminho')}: {location.pathname}
            </p>
          </div>
          <Button
            className="mt-3"
            title={t('label.pagina_inicial')}
            onClick={() => {
              navigate(authenticated ? '/eleicoes' : '/');
            }}
          />
        </div>
      </ErrorCard>
    </DefaultContent>
  );
};

export default ErrorView;
